import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
/* assets */
import logoShaia from "../../assets/azul-alt.svg";
import teacher from "../../assets/profe.png";
import profesor from "../../assets/profe-inst.png";
import { useLocation } from 'react-router-dom';
import { useMutation } from 'react-query';
import { getInstitutionByLicense } from '../../services/auth.service';


const SidebarIndex = ({ isInstitution, institution }) => {
  const [logo, setLogo] = useState(null);
  const { t } = useTranslation();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const code = queryParams.get("code");

  const mutation = useMutation(getInstitutionByLicense, {
    onSuccess: (data) => {
      if(data){
        setLogo(data.logo_black)
      }
    },
  });

  useEffect(() => {
    if(code){
      mutation.mutate(code)
    }
    // eslint-disable-next-line
  },[])

  return (
    <div className="max-w-100 bg-lightTheme md-max:hidden flex h-full flex-col gap-8">
      <div className="flex flex-row gap-6 p-8">
        <div className="max-w-[40%] flex-1">
          <img src={logoShaia} className="max-w-full" alt="Shaia" />
        </div>
        { logo && <div className="max-w-[40%] max-h-16 flex-1"><img src={logo} className='max-w-full max-h-full' alt={institution} /></div>}
      </div>
      <div className="mt-8 flex flex-col gap-4 px-8">
        <h3 className="leading-8">
          {t("bannerText1")}{" "}
          <span className="text-shaiaBlue font-extrabold">
            {t("bannerText2")}
          </span>
          .<br />¡{t("bannerText3")}!
        </h3>
        <p className="text-5 leading-6">{t("bannerText4")}</p>
      </div>
      <div className="w-full h-full flex flex-col justify-end">
        {isInstitution ? 
          <img src={profesor} className="max-w-full" alt="Profe explorador" />
          :
          <img src={teacher} className="max-w-full" alt="Profe explorador" />
        }
      </div>
    </div>
  );
};

export default SidebarIndex;
